// extracted by mini-css-extract-plugin
export default {"container":"IsVwK","share-icons":"J2D8i","shareIcons":"J2D8i","share-icon":"Bvb0s","shareIcon":"Bvb0s"};